export default __webpack_public_path__ + "static/media/jost-400-book.b049526f.woff";